import React from 'react';
import styled from 'styled-components';
import Icon from 'js/components/common/Icon';

const Container = styled.div`
  font-weight: 500;
`;

const NoticeIcon = styled(Icon)`
  margin-right: 0.5rem;
`;

export default ({ children, icon }) => (
  <Container>
    <NoticeIcon name={icon || 'exclamation-circle'} />
    {children}
  </Container>
);
